import "babel-polyfill";
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import vuetify from "./plugins/vuetify";
import { store } from "./store";
import firebase from "firebase/app";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
	faArrowUp,
	faArrowDown,
	faTimesCircle,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

library.add(faArrowUp, faArrowDown, faTimesCircle);

Vue.component("font-awesome-icon", FontAwesomeIcon);

Vue.config.productionTip = false;

let app = null;

firebase.auth().onAuthStateChanged(() => {
	if (!app) {
		new Vue({
			router,
			store,
			vuetify,
			render: (h) => h(App),
		}).$mount("#app");
	}
});
